/* tslint:disable */
/* eslint-disable */
import { UserDisplayModel as AceXFoundPortalCoreCaqModelsUserDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/user-display-model';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { UserDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsUserDisplayModelFormGroup } from '@/api/model-index';

export interface IPortalzugriffDisplayModel {
  externerBenutzer?: AceXFoundPortalCoreCaqModelsUserDisplayModel;
  id?: string;
  isPrimaererExternerBenutzer?: boolean;
  projektId?: string;
  projektideeId?: string;
  unregistrierterBenutzer?: null | string;
}
export class PortalzugriffDisplayModel extends BaseModel implements IPortalzugriffDisplayModel {
  externerBenutzer?: AceXFoundPortalCoreCaqModelsUserDisplayModel;
  id?: string;
  isPrimaererExternerBenutzer?: boolean;
  projektId?: string;
  projektideeId?: string;
  unregistrierterBenutzer?: null | string;
}
class BasePortalzugriffDisplayModelFormGroup extends FormGroup {
  private static _instance: PortalzugriffDisplayModelFormGroup;
  
  public static get Instance(): PortalzugriffDisplayModelFormGroup {
    this._instance = new PortalzugriffDisplayModelFormGroup({
      externerBenutzer: AceXFoundPortalCoreCaqModelsUserDisplayModelFormGroup.Instance,
      id: new FormControl(null),
      isPrimaererExternerBenutzer: new FormControl(null),
      projektId: new FormControl(null),
      projektideeId: new FormControl(null),
      unregistrierterBenutzer: new FormControl(null),
    });

    return this._instance;
  }
}


export class PortalzugriffDisplayModelFormGroup extends BasePortalzugriffDisplayModelFormGroup {
  public get ExternerBenutzer(): AceXFoundPortalCoreCaqModelsUserDisplayModelFormGroup {
    return this.controls["externerBenutzer"] as AceXFoundPortalCoreCaqModelsUserDisplayModelFormGroup;
  }
  public get Id(): FormControl {
    return this.controls["id"] as FormControl;
  }
  public get IsPrimaererExternerBenutzer(): FormControl {
    return this.controls["isPrimaererExternerBenutzer"] as FormControl;
  }
  public get ProjektId(): FormControl {
    return this.controls["projektId"] as FormControl;
  }
  public get ProjektideeId(): FormControl {
    return this.controls["projektideeId"] as FormControl;
  }
  public get UnregistrierterBenutzer(): FormControl {
    return this.controls["unregistrierterBenutzer"] as FormControl;
  }
  

}

export module PortalzugriffDisplayModelForm
  {
    export class FormFields
    {
      static _externerBenutzer: string = "externerBenutzer";
      static _id: string = "id";
      static _isPrimaererExternerBenutzer: string = "isPrimaererExternerBenutzer";
      static _projektId: string = "projektId";
      static _projektideeId: string = "projektideeId";
      static _unregistrierterBenutzer: string = "unregistrierterBenutzer";
    }
  }

